import React, {useState} from "react";
import close from '../Images/close-circle.svg'

const Header = ({dataHeader}) => {

    const isMobile = window.matchMedia('(max-width: 700px)')
    const [showModal, setShowModal] = React.useState(false);

    return (
        <div className={`w-full bg-cover relative md:h-[34vw] ${ dataHeader.video ? 'mt-20' : '' }`}
             style={{height: isMobile.matches ? '750px' : '', backgroundImage: !isMobile.matches ? `url(${dataHeader.background_image})` : `url(${dataHeader.background_image_mobile}`}}>
            <div className={`pt-8 pb-3 px-6 absolute w-full md:w-6/12 bottom-0 text-white`}>
                <div className={`cursor-pointer bg-[url('./Images/play.png')] hover:bg-[url('./Images/hover-play.svg')] bg-cover w-11 h-11 mb-4 ${dataHeader.video ? 'block' : 'hidden'}`}
                     onClick={() => setShowModal(true)}/>
                <p className={`mb-2 ${dataHeader.text1_type === 'header' ? 'text-sm md:text-base tracking-wider' : 'text-[27px] leading-[38px] font-bold'}`}>{dataHeader.text1}</p>
                <p className={`${dataHeader.video ? '' : 'md:mb-32 md:w-3/4 w-5/6'} ${dataHeader.text2_type === 'title' ? 'text-[27px] leading-[38px]' : 'text-base'}`}>{dataHeader.text2}</p>
            </div>
            {showModal ? (
                <>
                    <div
                        className="bg-[#00000080] justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[999] outline-none focus:outline-none">
                        <div className="relative w-11/12 h-5/6 my-6">
                            <div
                                className="relative border-0 relative flex flex-col w-full bg-transparent outline-none focus:outline-none h-full">
                                <div className="relative flex-auto py-8 md:py-8 md:px-12">
                                    <iframe width="100%" height="100%" src={dataHeader.video}
                                            title="VIDEO" frameBorder="0" className={`bg-black`}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen></iframe>
                                </div>
                                <div
                                    className="absolute top-0 right-0 flex items-center">
                                    <button
                                        className="text-white background-transparent outline-none focus:outline-none mb-1 ease-linear"
                                        type="button"
                                        onClick={() => setShowModal(false)}
                                    >
                                        <img src={close} alt=""/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    )
}

export default Header;
